<template>
<div>
  <b-modal v-bind:id="modId" v-bind:title="this.$i18n.t('login.forgot_password_title')" hide-footer>
    <p class="my-4">{{ $i18n.t("login.forgot_password_message") }}</p>
    <b-form-input id="inputEmailForReessue" v-model="inputEmailForReessue" type="text" class="mb-3"></b-form-input>
    <b-button variant="primary" block @click='sendMail'>{{ $i18n.t("login.send") }}</b-button>
    <b-button block @click='cancel'>{{ $i18n.t("common.cancel") }}</b-button>
  </b-modal>
</div>
</template>
<script>
import confirmModal from './ConfirmModal'
export default {
  components: {
    confirmModal
  },
  data () {
    return {
      errMsg: null,
      errSbj: null,
      inputEmailForReessue: this.$parent.inputEmailForReessue
    }
  },
  name: 'Modal',
  props: ['modId', 'titleMsg', 'msg', 'buttonMsg'],
  methods: {
    sendMail: function () {
      this.$parent.inputEmailForReessue = this.inputEmailForReessue
      this.$parent.modalResult = true
      this.confirmModal()
    },
    cancel: function () {
      this.$bvModal.hide('md-forgotPass')
    },
    confirmModal () {
      this.$emit('confirm')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ForgotPassModal.vue